<template>
    <!-- 平台权限管理 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/visitor_machine'}"  @click="$Common.pageJump('/visitor_machine',3)">访客机</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/visiting_teachers'}" @click="$Common.pageJump('/visiting_teachers',3)">被访老师人员库</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/temporary_visitor'}" @click="$Common.pageJump('/temporary_visitor',3)">临时访客人员库</li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'VisitorMachineManagement',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
</style>